import React, { PropsWithChildren, useMemo } from 'react';
import { useSelector } from 'react-redux';

import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardChips from 'components/Meteorology/Shared/QueryCard/Chips';
import QueryCardChip from 'components/Meteorology/Shared/QueryCard/Chip';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import useFluxAutomaticFilterSelector from 'utils/hooks/flux/automatic/filterSelector';
import { automaticOptionMap } from 'helper/flux/automatic';
import {
  selectFluxAutomaticControlPanelAutomaticStudyScenarios,
  selectFluxAutomaticControlPanelPastSimulations,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

// Resumo da consulta compartilhado por Base Diária, Base Mensal e RVX Multicenário —
// as três leem o mesmo estado do fluxAutomaticControlPanelReducer.
export default function QuerySummary({
  onOpenPanel,
  extraChips = [],
  action,
}: PropsWithChildren<{
  onOpenPanel: () => void;
  extraChips?: string[];
  action?: React.ReactNode;
}>) {
  const { currentSubOption } = useFluxAutomaticFilterSelector();
  const scenarios = useSelector(selectFluxAutomaticControlPanelAutomaticStudyScenarios);
  const pastSimulations = useSelector(selectFluxAutomaticControlPanelPastSimulations);

  const title = currentSubOption
    ? `${automaticOptionMap[currentSubOption.spatialSubdivision]} · ${currentSubOption.spacialSubdivisionOption.label}`
    : 'Nenhuma subdivisão selecionada';

  const chips = useMemo(() => {
    const result = [...extraChips];
    if (scenarios.length) result.push(`${scenarios.length} cenário(s)`);
    if (pastSimulations.length) result.push(`${pastSimulations.length} simulação(ões) antiga(s)`);
    return result;
  }, [extraChips, scenarios.length, pastSimulations.length]);

  return (
    <QueryCard>
      <QueryCardHeader label="Consulta atual" title={title} action={action}>
        {chips.length > 0 && (
          <QueryCardChips>
            {chips.map((chip) => <QueryCardChip key={chip}>{chip}</QueryCardChip>)}
          </QueryCardChips>
        )}
      </QueryCardHeader>
      <QueryCardTrigger onClick={onOpenPanel} />
    </QueryCard>
  );
}
